import type {
    CreateSavedPaymentMethodForm,
    CreateSavedPaymentMethodResponse,
    SavedPaymentMethod,
    SavedPaymentMethodFindQuery,
    SavedPaymentMethodResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/finance/saved-payment-method';

export class SavedPaymentMethodApi {
    public static async find(params: SavedPaymentMethodFindQuery): Promise<SavedPaymentMethod[]> {
        try {
            const { data } = await axios.get<SavedPaymentMethodResponse>(BASE_URL, { params });
            return data.savedPaymentMethods;
        } catch {
            return [];
        }
    }
    public static async get(id: string): Promise<SavedPaymentMethod> {
        const { data } = await axios.get<SavedPaymentMethod>(`${BASE_URL}/${id}`);
        return data;
    }

    public static async create(form: CreateSavedPaymentMethodForm): Promise<CreateSavedPaymentMethodResponse> {
        const { data } = await axios.post<CreateSavedPaymentMethodResponse>(BASE_URL, form);
        return data;
    }

    public static async archive(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }

    public static async makeDefault(id: string): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/default`);
    }
}
